<template>
  <div class="bg-gray-50 font-sans overflow-x-hidden">
    <!-- 导航栏 -->
    <nav class="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur shadow-sm">
      <div class="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8">
        <div class="flex justify-between items-center h-14 sm:h-16">
          <div class="flex items-center space-x-2">
            <img alt="" class="w-28 sm:w-32 md:w-40" src="@/assets/logo.png" />
          </div>
          <div class="hidden md:flex items-center space-x-4 lg:space-x-8">
            <a href="#home" class="text-gray-700 hover:text-primary transition-colors text-sm lg:text-base">首页</a>
            <a href="#services" class="text-gray-700 hover:text-primary transition-colors text-sm lg:text-base">产品服务</a>
            <a href="#about" class="text-gray-700 hover:text-primary transition-colors text-sm lg:text-base">关于我们</a>
            <a href="#contact" class="text-gray-700 hover:text-primary transition-colors text-sm lg:text-base">联系我们</a>
            <button @click="openLoginModal" class="gradient-blue text-white px-4 sm:px-6 py-1.5 sm:py-2 rounded-full hover:opacity-90 transition-opacity text-sm lg:text-base whitespace-nowrap">
              <i class="fa fa-user-o mr-1 sm:mr-2"></i>注册/登录
            </button>
          </div>
          <button class="md:hidden text-gray-700 p-2" @click="toggleMobileMenu">
            <i class="fa fa-bars text-xl"></i>
          </button>
        </div>
      </div>
      <div id="mobileMenu" ref="mobileMenuRef" class="hidden md:hidden bg-white border-t shadow-lg">
        <div class="px-4 py-3 space-y-2">
          <a href="#home" class="block text-gray-700 hover:text-primary py-2 text-base border-b border-gray-50">首页</a>
          <a href="#services" class="block text-gray-700 hover:text-primary py-2 text-base border-b border-gray-50">产品服务</a>
          <a href="#about" class="block text-gray-700 hover:text-primary py-2 text-base border-b border-gray-50">关于我们</a>
          <a href="#contact" class="block text-gray-700 hover:text-primary py-2 text-base border-b border-gray-50">联系我们</a>
          <button @click="openLoginModal" class="w-full gradient-blue text-white px-6 py-2.5 rounded-full text-base mt-2">
            立即登录
          </button>
        </div>
      </div>
    </nav>

    <!-- Banner区域 -->
    <section id="home" class="relative overflow-hidden pt-14 sm:pt-16">
      <div class="absolute inset-0 bg-gradient-to-br from-slate-900 via-blue-900 to-slate-800">
        <div class="absolute inset-0 opacity-30">
          <div class="absolute top-20 left-20 w-64 h-64 sm:w-80 sm:h-80 md:w-96 md:h-96 bg-blue-500 rounded-full blur-3xl animate-pulse"></div>
          <div class="absolute bottom-20 right-20 w-56 h-56 sm:w-72 sm:h-72 md:w-80 md:h-80 bg-cyan-400 rounded-full blur-3xl animate-pulse" style="animation-delay: 1s;"></div>
          <div class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-56 h-56 sm:w-64 sm:h-64 md:w-72 md:h-72 bg-blue-400 rounded-full blur-3xl animate-pulse" style="animation-delay: 2s;"></div>
        </div>
        <div class="absolute inset-0" style="background-image: radial-gradient(rgba(59, 130, 246, 0.1) 1px, transparent 1px); background-size: 50px 50px;"></div>
      </div>
      <video autoplay muted loop playsinline class="absolute inset-0 w-full h-full object-cover mix-blend-overlay opacity-100" crossorigin="anonymous" ref="videoRef">
        <!-- <source src="https://56baoli.com/hls/banner/banner.m3u8" type="application/vnd.apple.mpegurl"> -->
      </video>
      <div class="absolute inset-0 bg-gradient-to-r from-slate-900/90 via-slate-900/70 to-slate-900/50"></div>
      <div class="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-slate-900/30"></div>
      <div class="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8 relative z-10">
        <div class="min-h-[520px] sm:min-h-[580px] md:min-h-[680px] flex items-center py-8 sm:py-12">
          <div class="grid md:grid-cols-2 gap-6 sm:gap-10 md:gap-16 items-center w-full">
            <div class="text-white">
              <div class="inline-flex items-center space-x-2 bg-white/10 backdrop-blur px-3 sm:px-4 py-1.5 sm:py-2 rounded-full mb-4 sm:mb-6">
                <span class="w-1.5 sm:w-2 h-1.5 sm:h-2 bg-green-400 rounded-full animate-pulse"></span>
                <span class="text-xs sm:text-sm text-blue-200">科技驱动金融创新</span>
              </div>
              <h1 class="text-[clamp(2rem,6vw,4.5rem)] font-bold leading-tight mb-3 sm:mb-4 md:mb-6">
                真保数科
              </h1>
              <p class="text-[clamp(0.9rem,1.8vw,1.25rem)] text-gray-300 mb-3 sm:mb-4 md:mb-4 leading-relaxed max-w-lg">
                应收账款融资
              </p>
              <p class="text-[clamp(0.9rem,1.8vw,1.25rem)] text-gray-300 mb-3 sm:mb-4 md:mb-4 leading-relaxed max-w-lg">
                全线上操作
              </p>
              <p class="text-[clamp(0.9rem,1.8vw,1.25rem)] text-gray-300 mb-3 sm:mb-4 md:mb-4 leading-relaxed max-w-lg">
                高效便捷
              </p>
              <div class="flex flex-wrap gap-3 sm:gap-4">
                <button @click="openCalculateModal" class="bg-gradient-to-r from-blue-500 to-cyan-400 hover:from-blue-600 hover:to-cyan-500 text-white text-sm font-semibold px-6 py-3 rounded-full shadow-lg shadow-blue-500/30 hover:shadow-xl hover:shadow-blue-500/40 transition-all transform hover:-translate-y-1 sm:hidden">
                  <i class="fa fa-rocket mr-1"></i>立即测算
                </button>
                <button @click="scrollToServices" class="border-2 border-white/30 hover:border-white/50 text-white text-sm sm:text-base lg:text-lg font-semibold px-6 sm:px-8 lg:px-10 py-3 sm:py-4 rounded-full backdrop-blur transition-all hover:bg-white/10">
                  <i class="fa fa-play-circle mr-1 sm:mr-2"></i>了解更多
                </button>
              </div>
            </div>
            <div class="hidden md:block">
              <div class="bg-white/5 backdrop-blur-xl rounded-3xl p-6 lg:p-8 border border-white/10 shadow-2xl">
                <div class="grid grid-cols-2 gap-6 lg:gap-8">
                  <div class="text-center">
                    <div class="text-4xl lg:text-5xl font-bold bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent mb-1 lg:mb-2">1000+</div>
                    <div class="text-gray-400 text-xs lg:text-sm">服务企业</div>
                  </div>
                  <div class="text-center">
                    <div class="text-4xl lg:text-5xl font-bold bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent mb-1 lg:mb-2">30亿+</div>
                    <div class="text-gray-400 text-xs lg:text-sm">累计放款</div>
                  </div>
                  <div class="text-center">
                    <div class="text-4xl lg:text-5xl font-bold bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent mb-1 lg:mb-2">24h</div>
                    <div class="text-gray-400 text-xs lg:text-sm">快速放款</div>
                  </div>
                  <div class="text-center">
                    <div class="text-4xl lg:text-5xl font-bold bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent mb-1 lg:mb-2">98%</div>
                    <div class="text-gray-400 text-xs lg:text-sm">客户满意度</div>
                  </div>
                </div>
                <div class="mt-6 lg:mt-8 pt-4 border-t border-white/10">
                  <!-- <div class="flex items-center justify-center space-x-4">
                    <div class="flex -space-x-3">
                      <div class="w-8 h-8 lg:w-10 lg:h-10 rounded-full bg-gradient-to-r from-blue-500 to-cyan-400 flex items-center justify-center text-white text-xs font-bold">北</div>
                      <div class="w-8 h-8 lg:w-10 lg:h-10 rounded-full bg-gradient-to-r from-purple-500 to-pink-400 flex items-center justify-center text-white text-xs font-bold">领</div>
                      <div class="w-8 h-8 lg:w-10 lg:h-10 rounded-full bg-gradient-to-r from-orange-500 to-yellow-400 flex items-center justify-center text-white text-xs font-bold">通</div>
                    </div>
                    <p class="text-gray-400 text-xs lg:text-sm">已有 <span class="text-white font-semibold">3,286</span> 家企业获得融资</p>
                  </div> -->
                </div>
                <div class="flex sm:flex-row items-center justify-center gap-4 mt-6 relative">
                  <div>
                    <p class="text-lg text-gray-300 mb-2 sm:mb-2 md:mb-2 leading-relaxed max-w-lg">

                      简单一步，即可获取您的授信预审额度
                    </p>
                    <p class="text-gray-400 text-xs sm:text-sm">
                      真保平台会严格保护您的个人信息及商业隐私
                    </p>
                  </div>
                  <button @click="openCalculateModal" class="bg-gradient-to-r from-blue-500 to-cyan-400 hover:from-blue-600 hover:to-cyan-500 text-white text-sm sm:text-base font-semibold px-6 sm:px-8 py-3 sm:py-4 rounded-full shadow-lg shadow-blue-500/30 hover:shadow-xl hover:shadow-blue-500/40 transition-all transform hover:-translate-y-1 whitespace-nowrap">
                    <i class="fa fa-rocket mr-1 sm:mr-2"></i>立即测算
                  </button>
                  <img class="w-[35px] absolute top-[35px] right-[-5px] animate-bounce" src="@/assets/pick.png" alt="">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="absolute bottom-4 sm:bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce hidden sm:block">
        <div class="w-7 h-10 sm:w-8 sm:h-12 rounded-full border-2 border-white/30 flex items-start justify-center p-2">
          <div class="w-1.5 h-2.5 sm:h-3 bg-white/50 rounded-full animate-pulse"></div>
        </div>
      </div> -->
    </section>

    <!-- 服务特色 -->
    <section id="services" class="py-12 sm:py-16 md:py-20 bg-white">
      <div class="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8">
        <div class="text-center mb-8 sm:mb-12 md:mb-16">
          <h2 class="text-2xl sm:text-3xl font-bold text-gray-800 mb-2 sm:mb-4">我们的服务优势</h2>
          <p class="text-gray-600 text-sm sm:text-base max-w-2xl mx-auto px-2">依托金融科技能力，为中小企业提供高效、便捷、安全的应收账款融资服务</p>
        </div>
        <div class="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
          <div class="bg-gray-50 rounded-2xl p-6 sm:p-8 hover:shadow-lg transition-shadow group text-center">
            <div class="w-14 h-14 sm:w-16 sm:h-16 gradient-blue rounded-xl flex items-center justify-center mx-auto mb-4 sm:mb-6 group-hover:scale-110 transition-transform">
              <i class="fa fa-bolt text-white !text-xl sm:!text-2xl"></i>
            </div>
            <h3 class="text-lg sm:text-xl font-bold text-gray-800 mb-2 sm:mb-3">免确权，免抵押，免发票</h3>
            <!-- <p class="text-gray-600 text-sm sm:text-base">免确权，免抵押，免发票</p> -->
          </div>
          <div class="bg-gray-50 rounded-2xl p-6 sm:p-8 hover:shadow-lg transition-shadow group text-center">
            <div class="w-14 h-14 sm:w-16 sm:h-16 gradient-blue rounded-xl flex items-center justify-center mx-auto mb-4 sm:mb-6 group-hover:scale-110 transition-transform">
              <i class="fa fa-shield text-white !text-xl sm:!text-2xl"></i>
            </div>
            <h3 class="text-lg sm:text-xl font-bold text-gray-800 mb-2 sm:mb-3">线上操作，便捷高效</h3>
            <!-- <p class="text-gray-600 text-sm sm:text-base">线上操作，便捷高效</p> -->
          </div>
          <div class="bg-gray-50 rounded-2xl p-6 sm:p-8 hover:shadow-lg transition-shadow group text-center sm:col-span-2 lg:col-span-1">
            <div class="w-14 h-14 sm:w-16 sm:h-16 gradient-blue rounded-xl flex items-center justify-center mx-auto mb-4 sm:mb-6 group-hover:scale-110 transition-transform">
              <i class="fa fa-handshake-o text-white !text-xl sm:!text-2xl"></i>
            </div>
            <h3 class="text-lg sm:text-xl font-bold text-gray-800 mb-2 sm:mb-3">随借随还，灵活用款</h3>
            <!-- <p class="text-gray-600 text-sm sm:text-base">随借随还，灵活用款</p> -->
          </div>
        </div>
      </div>
    </section>

    <!-- 产品服务 -->
    <section id="products" class="py-12 sm:py-16 md:py-20 bg-gray-50">
      <div class="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8">
        <div class="text-center mb-8 sm:mb-12 md:mb-16">
          <h2 class="text-2xl sm:text-3xl font-bold text-gray-800 mb-2 sm:mb-4">核心产品</h2>
          <p class="text-gray-600 text-sm sm:text-base max-w-2xl mx-auto px-2">多样化的保理产品，满足不同企业的融资需求</p>
        </div>
        <div class="grid sm:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
          <div class="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
            <div class="h-36 sm:h-40 md:h-48 gradient-blue flex items-center justify-center">
              <i class="fa fa-truck text-white !text-4xl sm:!text-5xl md:!text-6xl opacity-80"></i>
            </div>
            <div class="p-4 sm:p-6 md:p-8">
              <h3 class="text-xl sm:text-2xl font-bold text-gray-800 mb-2 sm:mb-4">运费产品</h3>
              <p class="text-gray-600 text-sm sm:text-base mb-4 sm:mb-6"><i class="fa fa-check text-primary mr-2"></i>运到，运费就到！</p>
              <ul class="space-y-1.5 sm:space-y-2 mb-4 sm:mb-6">
                <li class="flex items-center text-gray-600 text-sm sm:text-base">对中国邮政速递、顺丰速运、京东物流、极兔快递等核心企业的应收运费融资</li>
                <!-- <li class="flex items-center text-gray-600 text-sm sm:text-base"><i class="fa fa-check text-primary mr-2"></i>线上操作，便捷高效</li>
                <li class="flex items-center text-gray-600 text-sm sm:text-base"><i class="fa fa-check text-primary mr-2"></i>随借随还，灵活用款</li> -->
              </ul>
            </div>
          </div>
          <div class="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
            <div class="h-36 sm:h-40 md:h-48 gradient-blue flex items-center justify-center">
              <i class="fa fa-file-text-o text-white !text-4xl sm:!text-5xl md:!text-6xl opacity-80"></i>
            </div>
            <div class="p-4 sm:p-6 md:p-8">
              <h3 class="text-xl sm:text-2xl font-bold text-gray-800 mb-2 sm:mb-4">电商产品</h3>
              <p class="text-gray-600 text-sm sm:text-base mb-4 sm:mb-6"><i class="fa fa-check text-primary mr-2"></i>以应收货款实现资金快速融通</p>
              <ul class="space-y-1.5 sm:space-y-2 mb-4 sm:mb-6">
                <li class="flex items-center text-gray-600 text-sm sm:text-base">对京东、淘宝、抖音、快手、拼多多等电商平台上的应收货款融资</li>
                <!-- <li class="flex items-center text-gray-600 text-sm sm:text-base"><i class="fa fa-check text-primary mr-2"></i>线上操作，便捷高效</li>
                <li class="flex items-center text-gray-600 text-sm sm:text-base"><i class="fa fa-check text-primary mr-2"></i>随借随还，灵活用款</li> -->
              </ul>
            </div>
          </div>
          <div class="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
            <div class="h-36 sm:h-40 md:h-48 gradient-blue flex items-center justify-center">
              <i class="fa fa-industry text-white !text-4xl sm:!text-5xl md:!text-6xl opacity-80"></i>
            </div>
            <div class="p-4 sm:p-6 md:p-8">
              <h3 class="text-xl sm:text-2xl font-bold text-gray-800 mb-2 sm:mb-4">其他传统行业</h3>
              <p class="text-gray-600 text-sm sm:text-base mb-4 sm:mb-6"><i class="fa fa-check text-primary mr-2"></i>传统贸易行业资金周转</p>
              <ul class="space-y-1.5 sm:space-y-2 mb-4 sm:mb-6">
                <li class="flex items-center text-gray-600 text-sm sm:text-base">对钢铁煤炭等大宗贸易业务、基建设备零配件等供应链业务的应收账款融资</li>
                <!-- <li class="flex items-center text-gray-600 text-sm sm:text-base"><i class="fa fa-check text-primary mr-2"></i>线上操作，便捷高效</li>
                <li class="flex items-center text-gray-600 text-sm sm:text-base"><i class="fa fa-check text-primary mr-2"></i>随借随还，灵活用款</li> -->
              </ul>
            </div>
          </div>
        </div>
        <p class="text-gray-600 text-sm sm:text-base max-w-2xl mx-auto text-center mt-6 sm:mt-8 px-2">想了解更多产品细节，
          <a href="https://supplier.56baoli.com/" target="_blank" class="underline hover:text-blue-600 dark:hover:text-blue-400">请注册供应商账号登录</a>
        </p>
      </div>
    </section>

    <!-- 关于我们 -->
    <section id="about" class="py-12 sm:py-16 md:py-20 gradient-blue">
      <div class="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8">
        <div class="grid md:grid-cols-2 gap-8 sm:gap-10 md:gap-12 items-center">
          <div class="text-white order-2 md:order-1">
            <h2 class="text-2xl sm:text-3xl font-bold mb-3 sm:mb-4 md:mb-6">关于真保数科</h2>
            <p class="text-blue-100 text-sm sm:text-base mb-4 sm:mb-6 leading-relaxed">
              真保数科平台是由北京弘运保科技有限公司研发运营的云端保理业务平台。平台综合运用大数据、RPA等技术，在中小企业供应商与保理人之间，架起一座桥梁。
            </p>
            <p class="text-blue-100 text-sm sm:text-base mb-6 sm:mb-8 leading-relaxed">
              为中小供应商提供应收账款融资服务，为保理人提供交易数据归集整理、应收账款计量核验、保理业务审批签约、保理风险控制等全链路技术支撑，全线上操作，高效便捷。
            </p>
            <div class="flex flex-wrap gap-3 sm:gap-4">
              <div class="bg-white/10 rounded-lg px-4 sm:px-6 py-3 sm:py-4">
                <div class="text-2xl sm:text-3xl font-bold">6年+</div>
                <div class="text-blue-200 text-xs sm:text-sm">行业经验</div>
              </div>


              <div class="bg-white/10 rounded-lg px-4 sm:px-6 py-3 sm:py-4">
                <div class="text-2xl sm:text-3xl font-bold">1000+</div>
                <div class="text-blue-200 text-xs sm:text-sm">已服务企业</div>
              </div>
              <div class="bg-white/10 rounded-lg px-4 sm:px-6 py-3 sm:py-4">
                <div class="text-2xl sm:text-3xl font-bold">30+</div>
                <div class="text-blue-200 text-xs sm:text-sm">合作机构</div>
              </div>
            </div>
          </div>
         <div class="bg-white/10 backdrop-blur rounded-2xl p-4 sm:p-6 md:p-8 order-1 md:order-2 w-[calc(100vw-1.5rem)] md:w-full">
            <div class="w-full rounded-lg overflow-hidden relative">
              <swiper
                :modules="[Autoplay]"
                :slides-per-view="1"
                :loop="true"
                :autoplay="{
                  delay: 4000,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: true,
                }"
                class="about-swiper w-full h-full"
              >
                <!-- 图片列表 -->
                <swiper-slide>
                  <img
                    src="@/assets/gaoxing.jpg"
                    alt="关于我们"
                    class="w-full h-full object-cover"
                    loading="lazy"
                  />
                </swiper-slide>
                <swiper-slide>
                  <img
                    src="@/assets/lun1.jpg"
                    alt="关于我们"
                    class="w-full h-full object-cover"
                    loading="lazy"
                  />
                </swiper-slide>
                <swiper-slide>
                  <img
                    src="@/assets/lun2.jpg"
                    alt="关于我们"
                    class="w-full h-full object-cover"
                    loading="lazy"
                  />
                </swiper-slide>
              </swiper>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 联系我们 -->
    <section id="contact" class="py-12 sm:py-16 md:py-20 bg-gray-50">
      <div class="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8">
        <div class="text-center mb-8 sm:mb-12 md:mb-16">
          <h2 class="text-2xl sm:text-3xl font-bold text-gray-800 mb-2 sm:mb-4">联系我们</h2>
          <p class="text-gray-600 text-sm sm:text-base max-w-2xl mx-auto px-2">如有合作意向或希望进一步了解，欢迎您与我们联系</p>
        </div>
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
          <div class="bg-white rounded-2xl p-4 sm:p-6 text-center shadow-lg">
            <div class="w-12 h-12 sm:w-14 sm:h-14 gradient-blue rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
              <i class="fa fa-map-marker text-white text-base sm:text-xl"></i>
            </div>
            <h3 class="text-base sm:text-lg font-bold text-gray-800 mb-1 sm:mb-2">北京总部</h3>
            <p class="text-gray-600 text-xs sm:text-sm">北京市朝阳区北辰东路8号院1号楼<br>（北辰时代大厦）20层2008号</p>
          </div>
          <div class="bg-white rounded-2xl p-4 sm:p-6 text-center shadow-lg">
            <div class="w-12 h-12 sm:w-14 sm:h-14 gradient-blue rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
              <i class="fa fa-map-marker text-white text-base sm:text-xl"></i>
            </div>
            <h3 class="text-base sm:text-lg font-bold text-gray-800 mb-1 sm:mb-2">重庆分部</h3>
            <p class="text-gray-600 text-xs sm:text-sm">重庆市江北区庆云路16号<br>国金中心T2塔楼32层</p>
          </div>
          <div class="bg-white rounded-2xl p-4 sm:p-6 text-center shadow-lg">
            <div class="w-12 h-12 sm:w-14 sm:h-14 gradient-blue rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
              <i class="fa fa-phone text-white text-base sm:text-xl"></i>
            </div>
            <h3 class="text-base sm:text-lg font-bold text-gray-800 mb-1 sm:mb-2">联系电话</h3>
            <p class="text-gray-600 text-xs sm:text-sm">010-64933553<br>工作日 9:00 - 18:00</p>
          </div>
          <div class="bg-white rounded-2xl p-4 sm:p-6 text-center shadow-lg">
            <div class="w-12 h-12 sm:w-14 sm:h-14 gradient-blue rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
              <i class="fa fa-envelope-o text-white text-base sm:text-xl"></i>
            </div>
            <h3 class="text-base sm:text-lg font-bold text-gray-800 mb-1 sm:mb-2">电子邮箱</h3>
            <p class="text-gray-600 text-xs sm:text-sm">service@56baoli.com<br>business@56baoli.com</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 页脚 -->
    <footer class="bg-slate-900 text-white py-8 sm:py-10 md:py-12">
      <div class="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8">
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 mb-6 sm:mb-8 gap-4 sm:gap-6">
          <div class="mb-2">
            <div class="flex items-center space-x-2 mb-3 sm:mb-4">
              <img alt="" class="w-1/2 sm:w-2/3" src="@/assets/logo3.png" />
            </div>
            <p class="text-gray-400 text-xs sm:text-sm leading-relaxed">
              专注于为中小企业提供高效、便捷、安全的应收账款融资服务
            </p>
          </div>
          <div class="mb-2">
            <h4 class="font-bold mb-2 sm:mb-4 text-sm sm:text-base">产品服务</h4>
            <ul class="space-y-1.5 sm:space-y-2 text-gray-400 text-xs sm:text-sm">
              <li><a href="#products" class="hover:text-white transition-colors">运费产品</a></li>
              <li><a href="#products" class="hover:text-white transition-colors">电商产品</a></li>
              <li><a href="#products" class="hover:text-white transition-colors">其他传统行业</a></li>
            </ul>
          </div>
          <div class="mb-2">
            <h4 class="font-bold mb-2 sm:mb-4 text-sm sm:text-base">加入我们</h4>
            <ul class="space-y-1.5 sm:space-y-2 text-gray-400 text-xs sm:text-sm">
              <li><a href="/#/offer" target="_blank" class="hover:text-white transition-colors">招聘信息</a></li>
            </ul>
          </div>
          <div class="mb-2">
            <h4 class="font-bold mb-2 sm:mb-4 text-sm sm:text-base">关注动态</h4>
            <div class="flex flex-wrap gap-4 sm:gap-6">
              <div>
                <img class="w-24" src="@/assets/wechat.png" alt="">
                <p class="text-xs sm:text-sm text-center mt-1 sm:mt-2">微信公众号</p>
              </div>
            </div>
          </div>
          <div class="mb-2">
            <h4 class="font-bold mb-2 sm:mb-4 text-sm sm:text-base">扫码1V1咨询</h4>
            <div class="flex flex-wrap gap-4 sm:gap-6">
              <div>
                <img class="w-24" src="@/assets/zhou.jpg" alt="">
                <p class="text-xs sm:text-sm text-center mt-1 sm:mt-2">周经理</p>
              </div>
              <div>
                <img class="w-24" src="@/assets/yang.jpg" alt="">
                <p class="text-xs sm:text-sm text-center mt-1 sm:mt-2">杨经理</p>
              </div>
            </div>
          </div>
        </div>
        <div class="border-t border-gray-700 pt-6 sm:pt-8 flex flex-col md:flex-row justify-center items-center">
          <a class="text-gray-400 text-xs sm:text-sm mb-3 md:mb-0 text-center" href="https://beian.miit.gov.cn/" target="_blank">Copyright©北京弘运保科技有限公司 京ICP备2020048651号-7</a>
        </div>
      </div>
    </footer>

    <!-- 立即测算弹窗 -->
    <div id="calculateModal" v-show="showCalculateModal" class="fixed inset-0 z-50">
      <div class="absolute inset-0 bg-black/50 backdrop-blur-sm" @click="closeCalculateModal"></div>
      <div class="absolute inset-0 flex items-center justify-center p-2 sm:p-4">
        <div class="bg-white rounded-2xl shadow-2xl w-full max-w-3xl relative overflow-hidden max-h-[98vh] sm:max-h-[95vh] overflow-y-auto">
          <button @click="closeCalculateModal" class="absolute top-3 right-3 sm:top-4 sm:right-4 text-gray-400 hover:text-gray-600 z-10 p-1">
            <i class="fa fa-times text-lg sm:text-xl"></i>
          </button>
          <div class="p-4 sm:p-6 md:p-10">
            <div class="text-center mb-6 sm:mb-8 md:mb-10">
              <div class="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 gradient-blue rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
                <i class="fa fa-calculator text-white text-lg sm:text-xl md:text-2xl"></i>
              </div>
              <h3 class="text-xl sm:text-2xl font-bold text-gray-800">立即测算额度</h3>
              <p class="text-gray-600 text-xs sm:text-sm mt-1 sm:mt-2">填写以下信息，快速获取您的授信预审额度</p>
            </div>
            <form @submit.prevent="submitCalculate">
              <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 md:gap-x-8 md:gap-y-6">
                <div>
                  <label class="block text-xs sm:text-sm font-medium text-gray-700 mb-1 sm:mb-2">您的企业名称</label>
                  <input type="text" v-model="calculateForm.companyName" class="w-full px-3 sm:px-4 py-2.5 sm:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary outline-none transition-all text-sm sm:text-base" placeholder="请输入企业全称">
                </div>
                <div>
                  <label class="block text-xs sm:text-sm font-medium text-gray-700 mb-1 sm:mb-2">* 联系人姓名</label>
                  <input type="text" v-model="calculateForm.contactPerson" required @invalid="handleInvalid($event, '请填写联系人姓名')" @input="$event.target.setCustomValidity('')" class="w-full px-3 sm:px-4 py-2.5 sm:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary outline-none transition-all text-sm sm:text-base" placeholder="请输入您的姓名">
                </div>
                <div>
                  <label class="block text-xs sm:text-sm font-medium text-gray-700 mb-1 sm:mb-2">* 您的联系方式</label>
                  <input type="tel" v-model="calculateForm.contactPhoneNumber" maxlength="13"  required @invalid="handleInvalid($event, '请填写联系方式')" @input="$event.target.setCustomValidity('')" class="w-full px-3 sm:px-4 py-2.5 sm:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary outline-none transition-all text-sm sm:text-base" placeholder="请输入手机号码">
                </div>
                <div>
                  <label class="block text-xs sm:text-sm font-medium text-gray-700 mb-1 sm:mb-2">* 短信验证码</label>
                  <div class="relative">
                    <input v-model="calculateForm.codeNum" type="text" maxlength="6" class="w-full px-3 sm:px-4 py-2.5 sm:py-3 pr-24 sm:pr-28 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary outline-none transition-all text-sm sm:text-base" placeholder="请输入验证码">
                    <button type="button" class="absolute right-1 top-1 bottom-1 px-2 sm:px-4 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-md font-medium transition-colors text-xs sm:text-sm" @click="sendSmsCode($event)">获取验证码</button>
                  </div>
                </div>
                <div>
                  <label class="block text-xs sm:text-sm font-medium text-gray-700 mb-1 sm:mb-2">* 甲方账期天数</label>
                  <input type="number" v-model="calculateForm.daysOfAccountPeriod" required @invalid="handleInvalid($event, '请填写甲方账期天数')" @input="$event.target.setCustomValidity('')" class="w-full px-3 sm:px-4 py-2.5 sm:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary outline-none transition-all text-sm sm:text-base" placeholder="请输入货物或服务完成后甲方的回款天数">
                </div>
                <div>
                  <label class="block text-xs sm:text-sm font-medium text-gray-700 mb-1 sm:mb-2">* 甲方月均回款金额（万元）</label>
                  <input type="number" v-model="calculateForm.monthlyAverageReceivables" required @invalid="handleInvalid($event, '请填写甲方月均回款金额')" @input="$event.target.setCustomValidity('')" class="w-full px-3 sm:px-4 py-2.5 sm:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary outline-none transition-all text-sm sm:text-base" placeholder="请输入甲方平均每个月的回款金额">
                </div>
              </div>
              <p class="text-xs text-gray-500 mt-4 sm:mt-6 mb-6 sm:mb-8 text-center">
                <i class="fa fa-shield text-primary mr-1"></i>
                我们承诺严格保护您的个人信息及商业隐私
              </p>
              <button type="submit" class="w-full gradient-blue text-white py-3 sm:py-4 rounded-lg font-semibold hover:opacity-90 transition-opacity text-base sm:text-lg">
                开始测算
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!-- 测算结果弹窗 -->
    <div id="resultModal" v-show="showResultModal" class="fixed inset-0 z-50">
      <div class="absolute inset-0 bg-black/50 backdrop-blur-sm" @click="closeResultModal"></div>
      <div class="absolute inset-0 flex items-center justify-center p-2 sm:p-4">
        <div class="bg-white rounded-2xl shadow-2xl w-full max-w-lg relative overflow-hidden max-h-[98vh] sm:max-h-[95vh] overflow-y-auto">
          <button @click="closeResultModal" class="absolute top-3 right-3 sm:top-4 sm:right-4 text-gray-400 hover:text-gray-600 z-10 p-1">
            <i class="fa fa-times text-lg sm:text-xl"></i>
          </button>
          <div class="p-4 sm:p-6 md:p-10 text-center">
            <div class="w-14 h-14 sm:w-16 sm:h-16 md:w-20 md:h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6">
              <i class="fa fa-check text-green-500 text-3xl sm:text-4xl"></i>
            </div>
            <h3 class="text-xl sm:text-2xl font-bold text-gray-800 mb-3 sm:mb-6">测算成功！</h3>
            <p class="text-gray-600 text-sm sm:text-base mb-3 sm:mb-4">恭喜您，通过初步测算，您获取到的额度是</p>
            <div class="text-3xl sm:text-4xl md:text-5xl font-bold text-primary mb-6 sm:mb-8">
              <span id="resultAmount">{{ resultAmount }}</span><span class="text-xl sm:text-2xl">万元</span>
            </div>
            <p class="text-gray-600 text-xs sm:text-sm mb-6 sm:mb-8 leading-relaxed">
              为保证服务质量，我们会尽快与您取得联系，<br>您也可以扫码或致电联系客户经理！
            </p>
            <div class="bg-gray-50 rounded-xl p-4 sm:p-6 mb-6 sm:mb-8">
              <div class="flex flex-wrap items-center justify-center gap-4 sm:gap-6">
                <div class="text-center">
                  <div class="w-20 h-20 sm:w-24 sm:h-24 md:w-28 md:h-28 bg-gray-200 rounded-lg flex items-center justify-center mb-2">
                    <img class="w-[60px] sm:w-[70px] md:w-[90px]" src="@/assets/zhou.jpg" alt="">
                  </div>
                  <p class="text-xs sm:text-sm text-gray-500">周经理</p>
                </div>
                <div class="text-center">
                  <div class="w-20 h-20 sm:w-24 sm:h-24 md:w-28 md:h-28 bg-gray-200 rounded-lg flex items-center justify-center mb-2">
                    <img class="w-[60px] sm:w-[70px] md:w-[90px]" src="@/assets/yang.jpg" alt="">
                  </div>
                  <p class="text-xs sm:text-sm text-gray-500">杨经理</p>
                </div>
                <div class="text-center">
                  <div class="w-20 h-20 sm:w-24 sm:h-24 md:w-28 md:h-28 bg-gray-200 rounded-lg flex items-center justify-center mb-2">
                    <img class="w-[60px] sm:w-[70px] md:w-[90px]" src="@/assets/wechat.png" alt="">
                  </div>
                  <p class="text-xs sm:text-sm text-gray-500">真保数科服务号</p>
                </div>
              </div>
            </div>
            <button @click="closeResultModal" class="w-full gradient-blue text-white py-3 sm:py-4 rounded-lg font-semibold hover:opacity-90 transition-opacity text-base sm:text-lg">
              我知道了
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 登录弹窗 -->
    <div id="loginModal" v-show="showLoginModal" class="fixed inset-0 z-50">
      <div class="absolute inset-0 bg-black/50 backdrop-blur-sm" @click="closeLoginModal"></div>
      <div class="absolute inset-0 flex items-center justify-center p-2 sm:p-4">
        <div class="bg-white rounded-2xl shadow-2xl w-full max-w-md relative">
          <button @click="closeLoginModal" class="absolute top-3 right-3 sm:top-4 sm:right-4 text-gray-400 hover:text-gray-600 z-10 p-1">
            <i class="fa fa-times text-lg sm:text-xl"></i>
          </button>
          <div class="p-4 sm:p-6 md:p-8">
            <div class="text-center mb-6 sm:mb-8">
              <div class="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 gradient-blue rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
                <i class="fa fa-user text-white text-lg sm:text-xl md:text-2xl"></i>
              </div>
              <h3 class="text-xl sm:text-2xl font-bold text-gray-800">系统登录</h3>
              <p class="text-gray-600 text-xs sm:text-sm mt-1 sm:mt-2">请选择您的登录入口</p>
            </div>
            <div class="space-y-3 sm:space-y-4">
              <button @click="goLogin(1)" class="w-full flex items-center justify-center space-x-3 py-3 sm:py-4 border-2 border-gray-200 rounded-xl hover:border-primary hover:bg-blue-50 transition-all group">
                <div class="w-10 h-10 sm:w-12 sm:h-12 gradient-blue rounded-lg flex items-center justify-center flex-shrink-0">
                  <i class="fa fa-building text-white text-base sm:text-xl"></i>
                </div>
                <div class="text-left min-w-0">
                  <div class="font-semibold text-gray-800 group-hover:text-primary text-sm sm:text-base">供应商登录</div>
                  <div class="text-[10px] sm:text-xs text-gray-500 truncate">查看额度、申请融资、管理账单</div>
                </div>
                <i class="fa fa-chevron-right text-gray-300 group-hover:text-primary text-sm sm:text-base flex-shrink-0"></i>
              </button>
              <button @click="goLogin(2)" class="w-full flex items-center justify-center space-x-3 py-3 sm:py-4 border-2 border-gray-200 rounded-xl hover:border-primary hover:bg-blue-50 transition-all group">
                <div class="w-10 h-10 sm:w-12 sm:h-12 bg-secondary rounded-lg flex items-center justify-center flex-shrink-0">
                  <i class="fa fa-bank text-white text-base sm:text-xl"></i>
                </div>
                <div class="text-left min-w-0">
                  <div class="font-semibold text-gray-800 group-hover:text-primary text-sm sm:text-base">金融机构登录</div>
                  <div class="text-[10px] sm:text-xs text-gray-500 truncate">管理业务、审核申请、数据统计</div>
                </div>
                <i class="fa fa-chevron-right text-gray-300 group-hover:text-primary text-sm sm:text-base flex-shrink-0"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import _service from '@/api/index'
import { ElMessage } from 'element-plus'
import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/css'
import { Autoplay } from 'swiper/modules'
import Hls from 'hls.js';


// 弹窗状态
const showCalculateModal = ref(false)
const showResultModal = ref(false)
const showLoginModal = ref(false)
const mobileMenuRef = ref(null)

// 测算表单数据
const calculateForm = ref({
  companyName: '',
  contactPerson: '',
  contactPhoneNumber: '',
  daysOfAccountPeriod: '',
  monthlyAverageReceivables: '',
  codeToken: '',
  codeNum: ''
})
// 测算结果金额
const resultAmount = ref(0)

// 移动端菜单切换
const toggleMobileMenu = () => {
  mobileMenuRef.value?.classList.toggle('hidden')
}

// 测算弹窗
const openCalculateModal = () => {
  showCalculateModal.value = true
  document.body.style.overflow = 'hidden'
}
const closeCalculateModal = () => {
  showCalculateModal.value = false
  document.body.style.overflow = ''
}

// 结果弹窗
const closeResultModal = () => {
  showResultModal.value = false
  document.body.style.overflow = ''
}

// 登录弹窗
const openLoginModal = () => {
  showLoginModal.value = true
  document.body.style.overflow = 'hidden'
}
const closeLoginModal = () => {
  showLoginModal.value = false
  document.body.style.overflow = ''
}

const isFirstLoad = ref(true)
// 提交测算
const submitCalculate = async () => {
  const { companyName, contactPerson, contactPhoneNumber, daysOfAccountPeriod, monthlyAverageReceivables } = calculateForm.value
  
  if (!contactPerson) {
    ElMessage.error('请填写联系人姓名')
    return
  }
  if (!contactPhoneNumber) {
    ElMessage.error('请填写联系方式')
    return
  }
  if (!/^1[3-9]\d{9}$/.test(contactPhoneNumber)) {
    ElMessage.error('请填写正确的手机号码')
    return
  }
  if (!daysOfAccountPeriod) {
    ElMessage.error('请填写甲方账期天数')
    return
  }
  if (!monthlyAverageReceivables) {
    ElMessage.error('请填写甲方月均回款金额')
    return
  }

  if (!isFirstLoad.value && !calculateForm.value.codeNum) {
    ElMessage.error('请填写验证码')
    return
  }

  const res = await _service.validateSmsCode({smsCode: calculateForm.value.codeNum, smsToken: calculateForm.value.codeToken});

  if(!res && !isFirstLoad.value) {
    // ElMessage.error('验证码错误')
    return
  }
  
  try {
    const addRes = await _service.addWebsiteData({
      companyName,
      contactPerson,
      contactPhoneNumber,
      daysOfAccountPeriod,
      monthlyAverageReceivables,
    })
    
    if (addRes) {
      resultAmount.value = addRes;
      isFirstLoad.value = false
      setTimeout(() => {
        if(res) {
          closeCalculateModal()
          showResultModal.value = true
        } else {
          // ElMessage.success('提交成功')
        }
        document.body.style.overflow = 'hidden'
      }, 300)
    } else {
      ElMessage.error('测算失败，请稍后重试')
    }
  } catch (error) {
    ElMessage.error('网络异常，请稍后重试')
  }
}

// 发送验证码
const sendSmsCode = (e) => {
  if(!calculateForm.value.contactPhoneNumber) {
    ElMessage.error('请填写联系方式')
    return
  }
  if(!/^1[3-9]\d{9}$/.test(calculateForm.value.contactPhoneNumber)) {
    ElMessage.error('请填写正确的手机号码')
    return
  }
  const btn = e.target
  let countdown = 60
  btn.disabled = true
  btn.classList.add('bg-gray-300', 'cursor-not-allowed')
  btn.classList.remove('bg-gray-100', 'hover:bg-gray-200')
  getCodeFun();
  
  const timer = setInterval(() => {
    btn.textContent = countdown + 's后重发'
    countdown--
    if (countdown < 0) {
      clearInterval(timer)
      btn.disabled = false
      btn.textContent = '获取验证码'
      btn.classList.remove('bg-gray-300', 'cursor-not-allowed')
      btn.classList.add('bg-gray-100', 'hover:bg-gray-200')
    }
  }, 1000)
}

const getCodeFun = async () => {
  const value = await _service.getCode({telephone: calculateForm.value.contactPhoneNumber});
  calculateForm.value.codeToken = value;
  if (value.errno == 0 || value) {
    ElMessage.success('已成功发送验证码，请注意查收');
  }
};

// 登录角色
 const goLogin = (type) => {
  if(type === 1) {
    window.open('https://supplier.56baoli.com/', '_blank')
  } else {
    window.open(`https://factor.56baoli.com/`, '_blank')
  }
}

// 平滑滚动
const scrollToServices = () => {
  document.getElementById('services').scrollIntoView({ behavior: 'smooth' })
}

const handleInvalid = (e, msg) => {
  e.target.setCustomValidity(msg)
}

const videoRef = ref(null);
const m3u8Url = ref('https://56baoli.com/hls/banner/banner.m3u8');
let hls = null;

const playVideo = (url) => {
  const video = videoRef.value;
  if (!video) return;
  // 销毁旧实例
  if (hls) hls.destroy();

  if (Hls.isSupported()) {
    hls = new Hls();
    hls.loadSource(url);
    hls.attachMedia(video);
    hls.on(Hls.Events.MANIFEST_PARSED, () => video.play());
  } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
    video.src = url;
  }
};

// 锚点平滑滚动
onMounted(() => {
  playVideo(m3u8Url.value)
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', (e) => {
      e.preventDefault()
      const target = document.querySelector(anchor.getAttribute('href'))
      if (target) {
        target.scrollIntoView({ behavior: 'smooth' })
        mobileMenuRef.value?.classList.add('hidden')
      }
    })
  })
})
onUnmounted(() => {
  if (hls) hls.destroy();
});
</script>

<style>
@import url('https://cdn.jsdelivr.net/npm/font-awesome@4.7.0/css/font-awesome.min.css');

.gradient-blue {
  background: linear-gradient(135deg, #1E40AF 0%, #3B82F6 50%, #06B6D4 100%);
}

/* 移动端滚动条优化 */
@media (max-width: 640px) {
  ::-webkit-scrollbar {
    width: 3px;
    height: 3px;
  }
  ::-webkit-scrollbar-thumb {
    background: rgba(59, 130, 246, 0.3);
    border-radius: 10px;
  }
}

/* 弹窗滚动优化 */
#calculateModal .overflow-y-auto,
#resultModal .overflow-y-auto {
  -webkit-overflow-scrolling: touch;
}
</style>